// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2-CKr","item":"PaymentsMobile_item__2SNNa","label":"PaymentsMobile_label__RQShX","amount":"PaymentsMobile_amount__3ModV"};